import { render, staticRenderFns } from "./OrderManagement.vue?vue&type=template&id=40763df0"
import script from "./OrderManagement.vue?vue&type=script&lang=ts"
export * from "./OrderManagement.vue?vue&type=script&lang=ts"
import style0 from "./OrderManagement.vue?vue&type=style&index=0&id=40763df0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports